import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';
import router from '@/router';

export const RequestToken = (params) => {
  const requestOptions = {
    method: 'POST',
    url: urls.auth,
    headers: {
      'Content-Type': 'application/json',
    },
    data: params
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RefreshToken = (refToken) => {
  let requestOptions = {
    method: 'PATCH',
    url: urls.auth,
    data: {
      refresh_token: refToken
    }
  };

  function redirectTo(subdomain) {
    const wlp = window.location.port;
    const port = wlp === "8080" || wlp === "8081" ? ":" + wlp : "";
    window.location.href = `http${
      !port ? "s" : ""
    }://${subdomain}.spheremail.co${port}/customers/login`;
  };

  return axios(requestOptions)
    .then(res => res.data)
    .catch(e => {
      if (e.response.data.errors && e.response.data.new_subdomain)
        redirectTo(e.response.data.new_subdomain)
      else {
        router.push("/login");
      }
    });
};

export const RemoveToken = () => {
  let requestOptions = {
    method: 'DELETE',
    url: urls.auth,
  };

  return axios(requestOptions)
    .catch((e) => console.log('del err', e));
}

export const GetUserData = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.account
  }

  return axios(requestOptions)
    .then(res => res.data)
    .catch(e => router.push('/login'));
}

export const CreateUserAccount = (params) => {
  let requestOptions = {
    method: 'POST',
    url: urls.account,
    data: params
  }

  return axios(requestOptions)
    .then(res => res.data)
}

export const GenerateVerificationCode = (params) => {
  let requestOptions = {
    method: 'POST',
    url: urls.account+'/generate_verification_code',
    data: params
  }

  return axios(requestOptions)
    .then(res => res.data)
}


export const ActivateUserLvl1 = (params) => {
  let requestOptions = {
    method: 'POST',
    url: urls.enterprises,
    data: params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateUserAccount = (params) => {
  let requestOptions = {
    method: 'PUT',
    url: urls.account,
    data: params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const ResetPassword = (email) => {
  let requestOptions = {
    method: 'POST',
    url: urls.reset_password,
    data: { email }
  }

  return axios(requestOptions)
    .then(res => res.data);
};

export const ValidateActivationCode = (code) => {
  let requestOptions = {
    method: 'POST',
    url: urls.validate_activation_code,
    data: {
      activation_code: code
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetOrgAdminLocations = (params) => {
  let requestOptions = {
    method: 'GET',
    url: urls.org_admin_locations,
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' }),
  }

  return axios(requestOptions)
    .then(res => res.data);
}


export const GetOrganizations = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.organizations
  }

  return axios(requestOptions)
    .then(res => res.data);
}


export const CreateNewLocation = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.new_location,
    data,
  }

  return axios(requestOptions)
    .then(res => res.data);
}